export const FETCH_STUDENTS = "FETCH_STUDENTS";

export const EDIT_STUDENT_INFO = "EDIT_STUDENT_INFO";
